import * as A from './Application';
import {ApplicationModeType} from './ApplicationModeType';

type Undetermined = {key: 'UndeterminedModalApplication'};
type Loading = {key: 'LoadingModalApplication'};

export const UndeterminedModalApplication: Undetermined = {key: 'UndeterminedModalApplication'};
export const LoadingModalApplication: Loading = {key: 'LoadingModalApplication'};

export class ValidModalApplication {
  public static create(mode: ApplicationModeType, application: A.InvalidApplication | A.ValidApplication) {
    return new ValidModalApplication(mode, application);
  }

  public readonly key = 'ValidModalApplication';

  private constructor(
    public readonly mode: ApplicationModeType,
    public readonly application: A.InvalidApplication | A.ValidApplication
  ) {}
}

export class InvalidModalApplication {
  public static create(mode: ApplicationModeType, application: A.InvalidApplication | A.ValidApplication) {
    return new InvalidModalApplication(mode, application);
  }

  public readonly key = 'InvalidModalApplication';

  private constructor(
    public readonly mode: ApplicationModeType,
    public readonly application: A.InvalidApplication | A.ValidApplication
  ) {}
}

export type ModalApplication = Undetermined | Loading | ValidModalApplication | InvalidModalApplication;

type ExhaustiveModalApplicationOptions<TReturn> = {
  Invalid: (a: InvalidModalApplication) => TReturn;
  Valid: (a: ValidModalApplication) => TReturn;
  Undetermined: (a: Undetermined | Loading) => TReturn;
};

type PartialModalApplicationOptions<TReturn> = {
  Invalid?: (a: InvalidModalApplication) => TReturn;
  Valid?: (a: ValidModalApplication) => TReturn;
  Undetermined?: (a: Undetermined | Loading) => TReturn;
  _: (a: ModalApplication) => TReturn;
};
const isExhaustive = <TReturn>(
  options: ModalApplicationOptions<TReturn>
): options is ExhaustiveModalApplicationOptions<TReturn> => !!options.Invalid && !!options.Valid;

type ModalApplicationOptions<TReturn> =
  | ExhaustiveModalApplicationOptions<TReturn>
  | PartialModalApplicationOptions<TReturn>;

export const matchModalApplication = <TReturn>(
  application: ModalApplication,
  options: ModalApplicationOptions<TReturn>
): TReturn => {
  switch (application.key) {
    case 'InvalidModalApplication':
      return isExhaustive(options)
        ? options.Invalid(application)
        : options.Invalid
        ? options.Invalid(application)
        : options._(application);
    case 'ValidModalApplication':
      return isExhaustive(options)
        ? options.Valid(application)
        : options.Valid
        ? options.Valid(application)
        : options._(application);
    case 'UndeterminedModalApplication':
    case 'LoadingModalApplication':
      return isExhaustive(options)
        ? options.Undetermined(application)
        : options.Undetermined
        ? options.Undetermined(application)
        : options._(application);
  }
};
